import DetailPanel from "./detailPanel.container";

export default DetailPanel;